import { render, staticRenderFns } from "./addFilmRecord.vue?vue&type=template&id=700b2fb3&scoped=true&"
import script from "./addFilmRecord.vue?vue&type=script&lang=js&"
export * from "./addFilmRecord.vue?vue&type=script&lang=js&"
import style0 from "./addFilmRecord.vue?vue&type=style&index=0&id=700b2fb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b2fb3",
  null
  
)

export default component.exports